import { QuoteEmail } from "./email.model";
import { QuoteLocation } from "./quote-location.model";
import { Client } from "../../client/client.model";
import { BaseUser } from "../../user/base-user.model";
import { currencies } from "../../shared/currencies/currencies.const";
import { Package } from "../quote-form/quote-package/package.model";
import { BaseLclQuote } from "./quote-base-lcl.model";
import { LocalCostLabel } from "./local-cost-label.model";
import { Insurance } from "./insurance.model";
import { ContainerName } from "app/shared/container/container-name.type.const";

export class MultiQuote extends BaseLclQuote {
  constructor(
    protected id: number,
    protected displayId: string,
    protected groupId: number,
    protected ref: string,
    protected sender: BaseUser,
    protected createdBy: BaseUser,
    protected status: string,
    protected quoteType: string,
    protected direction: string,
    protected incotermType: string,
    protected clients: Client[],
    protected hasOrigin: boolean,
    protected hasDestination: boolean,
    protected originLocations: QuoteLocation[],
    protected destinationLocations: QuoteLocation[],
    protected localCostLabels: LocalCostLabel[],
    protected createdAt: Date,
    protected updatedAt: Date,
    protected updatedBy: BaseUser,
    protected openedAt: Date,
    protected validFrom: Date,
    protected validTo: Date,
    protected weight: number,
    protected measurement: number,
    protected pieces: number,
    protected comment: string,
    protected showRateSurcharges = false,
    protected showCarrier = false,
    protected showInland = false,
    protected showTotal = false,
    protected totalCurrency = null,
    protected showInvoiceInfo = false,
    protected invoiceCurrency = false,
    protected groupRoutes = false,
    protected email: QuoteEmail,
    protected internalComment: string,
    protected customTerms: string,
    protected fileName: string,
    protected fileNameInternal: string,
    protected averageMargin: number,
    protected averageMarginPercent: number,
    protected inquiry: string,
    protected source: string,
    protected insurance: Insurance | null,
    protected reasonOfDecline: string,
    protected input: string | null,
    protected offerLanguage: string | null,
    protected groupOriginSurcharges = false,
    protected groupDestinationSurcharges = false,
    protected groupOriginSurchargesCurrency = currencies.usd.value,
    protected groupDestinationSurchargesCurrency = currencies.usd.value,
    protected packages: Package[],
    protected chargeableWeight: number,
    protected ldm: number,
    protected equipment: ContainerName[],
    protected summaryCurrency: string,
  ) {
    super(
      id,
      displayId,
      groupId,
      ref,
      sender,
      createdBy,
      status,
      quoteType,
      direction,
      incotermType,
      clients,
      hasOrigin,
      hasDestination,
      originLocations,
      destinationLocations,
      localCostLabels,
      createdAt,
      updatedAt,
      updatedBy,
      openedAt,
      validFrom,
      validTo,
      weight,
      measurement,
      pieces,
      comment,
      showRateSurcharges,
      showCarrier,
      showInland,
      showTotal,
      totalCurrency,
      showInvoiceInfo,
      invoiceCurrency,
      groupRoutes,
      email,
      internalComment,
      customTerms,
      fileName,
      fileNameInternal,
      averageMargin,
      averageMarginPercent,
      inquiry,
      source,
      insurance,
      reasonOfDecline,
      input,
      offerLanguage,
      groupOriginSurcharges,
      groupDestinationSurcharges,
      groupOriginSurchargesCurrency,
      groupDestinationSurchargesCurrency,
      packages,
      chargeableWeight,
      ldm,
    );
  }

  public getEquipment(): ContainerName[] {
    return this.equipment;
  }

  public setEquipment(eq: ContainerName[]): void {
    this.equipment = eq;
  }

  public getSummaryCurrency(): string {
    return this.summaryCurrency;
  }

  public setSummaryCurrency(summaryCurrency: string): void {
    this.summaryCurrency = summaryCurrency;
  }

  public isValid(): boolean {
    if (!this.hasOrigin && !this.hasDestination) {
      return false;
    }
    if (this.hasOrigin && !this.originLocations.length) {
      return false;
    }
    if (this.hasDestination && !this.destinationLocations.length) {
      return false;
    }

    return (
      (this.getEquipment() && this.getEquipment().length > 0) ||
      (!!this.weight && !!this.measurement)
    );
  }

  public isSendable(): boolean {
    return this.isValid() && this.clients && this.clients.length > 0;
  }
}
